// apps/web/src/pages/Login.tsx (добавим отладочную информацию)
import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Card,
  CardContent,
} from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../api/client';
import { checkApiHealth, testLogin } from '../utils/checkApi';
import { environment } from '../config/environment';

const Login: React.FC = () => {
  const [email, setEmail] = useState('admin@gym.local');
  const [password, setPassword] = useState('admin123');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [apiStatus, setApiStatus] = useState<string>('Checking...');
  const navigate = useNavigate();

  useEffect(() => {
    // Проверяем доступность API при загрузке
    const checkApi = async () => {
      const result = await checkApiHealth(environment.apiBaseUrl);
      setApiStatus(result.ok ? 'API is available' : 'API is not available');
    };
    checkApi();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email || !password) {
      setError('Email and password are required');
      return;
    }

    try {
      setLoading(true);

      const testResult = await testLogin(environment.apiBaseUrl, email, password);

      if (testResult.ok) {
        const response = await apiClient.login(email, password);

        if (response && response.token) {
          apiClient.auth.login(email, password);
          navigate('/');
        } else {
          throw new Error('Invalid response from server');
        }
      } else {
        throw new Error(`API returned ${testResult.data?.error || 'unknown error'}`);
      }
    } catch (err) {
      console.error('Login error details:', err);
      setError(err instanceof Error ? err.message : 'Login failed. Check credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{ mt: 4, minHeight: '80vh', display: 'flex', alignItems: 'center' }}
    >
      <Box width="100%">
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="body2" color="textSecondary">
              API Status: {apiStatus}
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              Backend URL: {environment.apiBaseUrl}
            </Typography>
          </CardContent>
        </Card>

        <Paper elevation={3} sx={{ p: 4 }}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={4}>
            <LockIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
            <Typography variant="h4" component="h1" gutterBottom>
              Gym Management System
            </Typography>
            <Typography variant="body1" color="textSecondary">
              Admin Login
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              required
              autoFocus
            />

            <TextField
              label="Password"
              type="password"
              fullWidth
              margin="normal"
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3, mb: 2, py: 1.5 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
            </Button>
          </form>

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="textSecondary">
              Default credentials:
            </Typography>
            <Typography variant="body2" color="textSecondary" fontFamily="monospace">
              admin@gym.local / admin123
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
